/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from 'react'
import { isNotEmpty } from '../../../../../../_metronic/helpers'
import { useListView } from '../core/ListViewProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import axios from 'axios'
import { toast } from 'react-toastify'
import { ADD_SERVICES, SERVICE_CATEGORY_DATA } from '../../../../../modules/auth/core/_requests'
import Tagify from '@yaireo/tagify'
import "@yaireo/tagify/src/tagify.scss";

type Props = {
  isUserLoading: boolean
  user: any
}

interface Option {
  id: string;
  name: string;
}

type Service = {
  id: number;
  title: string;
  key_points: string;
  price: number;
  offer: number;
  description: string;
  category_id: string;
  category_name: string;
}

const UserEditModalForm: FC<Props> = ({ user, isUserLoading }) => {
  const { setItemIdForUpdate } = useListView()
  const { refetch } = useQueryResponse()

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const [options, setOptions] = useState<Option[]>([]);
  const [title, setTitle] = useState(user.title ? user.title : '');
  const [keyPoints, setKeyPoints] = useState(user.key_points ? user.key_points : '');
  const [inclusive, setInclusive] = useState(user.inclusive ? user.inclusive : '');
  const [exclusive, setExclusive] = useState(user.exclusive ? user.exclusive : '');
  const [type, setType] = useState(user.type ? user.type : '');
  const [price, setPrice] = useState(user.price ? user.price : '');
  const [offer, setOffer] = useState(user.offer ? user.offer : '');
  const [checkpointsArray, setChecPointArray] = useState(user.check_points ? user.check_points : '');
  const [image, setImage] = useState<File | null>(null);
  const [previousImage] = useState(user.image ? user.image : null);
  const [category, setCategory] = useState(user.category ? user.category : '');
  const [description, setDescription] = useState(user.description ? user.description : '');
  const checkpoints = useRef(null);
  const keypoints = useRef(null);

  useEffect(() => {
    if (checkpoints.current) {
      new Tagify(checkpoints.current);
    }
    if (keypoints.current) {
      new Tagify(keypoints.current);
    }
  }, []);

  useEffect(() => {
    axios.get(SERVICE_CATEGORY_DATA)
      .then(response => {
        setOptions(response.data);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append('title', title);
      formData.append('key_points', keyPoints);
      if (image) {
        formData.append('image', image);
      }
      formData.append('inclusive', inclusive);
      formData.append('exclusive', exclusive);
      formData.append('type', type);
      formData.append('check_points', checkpointsArray);
      formData.append('price', price);
      formData.append('offer', offer);
      formData.append('category', category);
      formData.append('description', description);
      if (isNotEmpty(user.id)) {
        formData.append('id', `${user.id}`);
      }

      const response = await axios.post(ADD_SERVICES, formData);

      if (response.data.status == 1) {
        toast.success(response.data.message);
        cancel(true)
      }
      else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
<>
        <form onSubmit={handleSubmit} className="d-flex flex-column gap-6">
          <div className="form-group">
            <label className="form-label required fw-semibold fs-6 mb-2">Title</label>
            <input 
              type="text" 
              className="form-control form-control-solid" 
              value={title} 
              onChange={(event) => setTitle(event.target.value)} 
              placeholder="Enter service title"
              required 
            />
          </div>

          <div className="form-group">
            <label className="form-label fw-semibold fs-6 mb-2">Image</label>
            <div className="d-flex flex-column gap-3">
              <input 
                id="image" 
                type="file" 
                className="form-control form-control-solid" 
                onChange={(event) => setImage(event.target.files?.[0] || null)}
                accept="image/*"
              />
              {previousImage && (
                <div className="mt-2">
                  <img 
                    src={previousImage} 
                    className="rounded shadow-sm" 
                    height={100} 
                    alt="Service preview" 
                  />
                </div>
              )}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label fw-semibold fs-6 mb-2">Key Points</label>
            <input 
              ref={keypoints} 
              type="text" 
              className="form-control form-control-solid" 
              value={keyPoints} 
              onChange={(event) => setKeyPoints(event.target.value)} 
              placeholder="Enter key points"
            />
          </div>

          <div className="form-group">
            <label className="form-label fw-semibold fs-6 mb-2">Inclusion</label>
            <input 
              type="text" 
              className="form-control form-control-solid" 
              value={inclusive} 
              onChange={(event) => setInclusive(event.target.value)} 
              placeholder="Enter inclusions"
            />
          </div>

          <div className="form-group">
            <label className="form-label fw-semibold fs-6 mb-2">Exclusion</label>
            <input 
              type="text" 
              className="form-control form-control-solid" 
              value={exclusive} 
              onChange={(event) => setExclusive(event.target.value)} 
              placeholder="Enter exclusions"
            />
          </div>

          <div className="form-group">
            <label className="form-label required fw-semibold fs-6 mb-2">Type</label>
            <select 
              className="form-select form-select-solid" 
              value={type} 
              onChange={(event) => setType(event.target.value)}
            >
              <option value="Select">Select type</option>
              <option value="Service">Service</option>
              <option value="Product">Product</option>
            </select>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label fw-semibold fs-6 mb-2">Price</label>
                <input 
                  type="number" 
                  className="form-control form-control-solid" 
                  value={price} 
                  onChange={(event) => setPrice(event.target.value)} 
                  placeholder="Enter price"
                  required 
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="form-label fw-semibold fs-6 mb-2">Offered Price</label>
                <input 
                  type="number" 
                  className="form-control form-control-solid" 
                  value={offer} 
                  onChange={(event) => setOffer(event.target.value)} 
                  placeholder="Enter offered price"
                  required 
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label fw-semibold fs-6 mb-2">Category</label>
            <select 
              className="form-select form-select-solid" 
              value={category} 
              onChange={(event) => setCategory(event.target.value)} 
              required
            >
              <option value="">Select category</option>
              {options.map(option => (
                <option key={option.id} value={option.id}>{option.name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label fw-semibold fs-6 mb-2">Description</label>
            <textarea 
              value={description} 
              onChange={(event) => setDescription(event.target.value)} 
              className="form-control form-control-solid" 
              rows={3}
              placeholder="Enter service description"
            />
          </div>

          <div className="form-group">
            <label className="form-label fw-semibold fs-6 mb-2">Check Points</label>
            <textarea 
              ref={checkpoints} 
              onChange={(event) => setChecPointArray(event.target.value)} 
              className="form-control form-control-solid" 
              value={checkpointsArray} 
              rows={3}
              placeholder="Enter check points"
            />
          </div>

          <div className="d-flex justify-content-end gap-3">
            <button 
              type="button" 
              className="btn btn-light" 
              onClick={() => cancel()}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={isUserLoading}
            >
              {isUserLoading ? (
                <span className="indicator-label">Please wait...</span>
              ) : (
                <span className="indicator-label">Save Changes</span>
              )}
            </button>
          </div>
        </form>
      </>
  )
}

export { UserEditModalForm }
